import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import moment from "moment";
import "./AccordionEditUser.css";

import {
  BagianConstant,
  RoleConstant,
  kepalaShiftTimOne,
  kepalaShiftTimTwo,
  posisiConstant,
} from "../../constant";
import DeleteIcon from "../../asset/delete_icon.png";
import ContractIcon from "../../asset/contract-icon.png";
import axios from "axios";
import { postAxios } from "../../util/postAxios";
import {
  formatJamKerja,
  parseJamKerja,
  hasRole,
  normalizeRoles,
} from "../../util/function";

const Modal = ({ title, subtitle, onClose, footer, size = "", children }) =>
  createPortal(
    <div className="modal-overlay">
      <div className={`modal ${size}`} role="dialog" aria-modal="true">
        <div className="modal__header">
          <div>
            <h3 className="modal__title">{title}</h3>
            {subtitle && <p className="modal__subtitle">{subtitle}</p>}
          </div>
          {onClose && (
            <button
              type="button"
              className="modal__close"
              aria-label="Tutup"
              onClick={onClose}
            >
              &times;
            </button>
          )}
        </div>
        {children && <div className="modal__body">{children}</div>}
        {footer && <div className="modal__footer">{footer}</div>}
      </div>
    </div>,
    document.body
  );

const Field = ({ label, full, danger, children }) => (
  <div
    className={`field ${full ? "field--full" : ""} ${
      danger ? "field--danger" : ""
    }`}
  >
    <label className="field__label">{label}</label>
    {children}
  </div>
);

const Radio = ({ label, checked, onSelect }) => (
  <label className="radio">
    <input type="radio" checked={checked} onChange={onSelect} />
    <span>{label}</span>
  </label>
);

const Avatar = ({ url, name, size = "sm" }) => {
  const initial = (name || "?").trim().charAt(0).toUpperCase();
  return (
    <span className={`avatar avatar--${size}`}>
      {url ? (
        <img src={url} alt={name || "Foto karyawan"} />
      ) : (
        <span className="avatar__initial">{initial}</span>
      )}
    </span>
  );
};

// Perkecil gambar (maks 512px) lalu jadikan JPEG base64 sebelum diunggah
const compressImage = (file, maxSize = 512, quality = 0.85) =>
  new Promise((resolve, reject) => {
    const objectUrl = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
      const canvas = document.createElement("canvas");
      canvas.width = Math.round(img.width * scale);
      canvas.height = Math.round(img.height * scale);
      const ctx = canvas.getContext("2d");
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      URL.revokeObjectURL(objectUrl);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    img.onerror = () => {
      URL.revokeObjectURL(objectUrl);
      reject(new Error("Gagal membaca gambar"));
    };
    img.src = objectUrl;
  });

const AccordionEditUser = ({
  dataUser,
  data,
  editType,
  index,
  peopleInfo,
  setPeopleInfo,
  setIsPopupContract,
  setDataPickContract,
  setDataPickHistoryContract,
  handleOpenNewContract,
  setIsPopUpListContract,
  setIsCreated,
  setIsReload,
}) => {
  const getToken = localStorage.getItem("auth")
    ? localStorage.getItem("auth")
    : null;
  const roleUser = localStorage.getItem("user");
  const jsonRole = JSON.parse(roleUser);
  const [initialExpand, setInitialExpand] = useState(false);
  const id = data.id;
  const [noNPWP, setNoNPWP] = useState(data.npwpNumber);
  const [noRekening, setNoRekening] = useState(data.bankAccountNumber);
  const [nama, setNama] = useState(data.name);
  const [email, setEmail] = useState(data.email);
  const [telepon, setTelepon] = useState(data.phoneNumber);
  const [bagian, setBagian] = useState(data.bagian);
  const [alamat, setAlamat] = useState(data.alamat);
  const [shift, setShift] = useState(data.shift);
  const [valueEmployeeType, setValueEmployeeType] = useState(data.employeeType);
  const [role, setRole] = useState(normalizeRoles(data.role)); // array
  const [roleError, setRoleError] = useState("");
  const [posisi, setPosisi] = useState(data.position);
  const [tempatTanggalLahir, setTempatTanggalLahir] = useState(
    data.tempatTanggalLahir
  );
  const [statusPerkawinan, setStatusPerkawinan] = useState(
    data.statusPerkawinan
  );
  const [jumlahAnak, setJumlahAnak] = useState(data.jumlahAnak);

  const [gajiPokok, setGajiPokok] = useState(data.basicSallary);
  const [gajiProbation, setGajiProbation] = useState(
    data.basicSallaryProbation
  );
  const [kurangBayar, setKurangBayar] = useState(data.kurangBayar);
  const [potonganBpjsTK, setPotonganBpjsTK] = useState(data.bpjsTK);
  const [potonganBpjsK, setPotonganBpjsK] = useState(data.bpjsK);
  const [lebihBayar, setLebihBayar] = useState(data.lebihBayar);
  const [uangShift, setUangShift] = useState(data.shiftSatu);
  const [lemburLibur, setLemburLibur] = useState(data.lemburLibur);
  const [workingShiftOne, setWorkingShiftOne] = useState(data.workingShiftOne);
  const [lemburLiburProbation, setLemburLiburProbation] = useState(
    data.lemburLiburProbation
  );
  const [uangMakan, setUangMakan] = useState(data.uangMakan);
  const [uangTransport, setUangTransport] = useState(data.uangTransport);
  const [cicilanKasbon, setCicilanKasbon] = useState(data.kasbon);
  const [tidakMasuk, setTidakMasuk] = useState(data.tidakMasuk);
  const [jamKerja, setJamKerja] = useState(data.totalWorking / 3600);
  const [jamKerjaProbation, setJamKerjaProbation] = useState(
    data.totalWorkingProbation / 3600
  );
  const [lembur, setLembur] = useState(data.jamOT);
  const [kontrakAwal, setKontrakAwal] = useState(data.kontrakAwal);
  const [setengahHari, setSetengahHari] = useState(data.setengahHari / 3600);
  const [confirmation, setConfirmation] = useState(false);
  const [statusMessage, setStatusMessage] = useState("");
  const [kepalaShift, setKepalaShift] = useState(data.kepalaShift);

  const [statusProbation, setStatusProbation] = useState(data.probation);
  const [keteranganKurangBayar, setKeteranganKurangBayar] = useState(
    data.keteranganKurangBayar
  );
  const [keteranganLebihBayar, setKeteranganLebihBayar] = useState(
    data.keteranganLebihBayar
  );
  const [lemburWaktuLibur, setLemburWaktuLibur] = useState(data.jamOTLibur);
  const [displayJamLebih, setDisplayJamLebih] = useState(
    formatJamKerja(data.jamLebih)
  );

  const [probationStart, setProbationStart] = useState(data.probationStart);
  const [probationUntil, setProbationUntil] = useState(data.probationUntil);

  const [fotoUrl, setFotoUrl] = useState(null);
  const [fotoLoading, setFotoLoading] = useState(false);
  const [fotoError, setFotoError] = useState("");
  const fileInputRef = useRef(null);

  const timeToSecond = (data) => {
    let hour = Number(data);
    return hour * 3600;
  };

  const toggleRole = (item) => {
    setRoleError("");
    setRole((prev) =>
      prev.includes(item) ? prev.filter((r) => r !== item) : [...prev, item]
    );
  };

  const validateData =
    jsonRole.tim === 1 ? kepalaShiftTimOne : kepalaShiftTimTwo;

  const isAdmin = hasRole(jsonRole, "hrd_admin", "super_user");
  const isNewPayroll = jsonRole.isNew === true;
  const showCheckbox = isAdmin && !isNewPayroll;
  const canSeeContract =
    dataUser.tim === 1 && hasRole(dataUser, "hrd_admin", "super_user");
  const isDeactivated = data.deviceId === "deactivate";
  const toggleExpand = () => setInitialExpand(!initialExpand);

  const handleCancel = (data) => {
    setNoNPWP(data.npwpNumber);
    setNoRekening(data.bankAccountNumber);
    setNama(data.name);
    setEmail(data.email);
    setTelepon(data.phoneNumber);
    setBagian(data.bagian);
    setAlamat(data.alamat);
    setValueEmployeeType(data.employeeType);
    setJumlahAnak(data.jumlahAnak);
    setStatusPerkawinan(data.statusPerkawinan);
    setShift(data.shift);
    setRole(normalizeRoles(data.role));
    setRoleError("");
    setPosisi(data.position);
    setTempatTanggalLahir(data.tempatTanggalLahir);
    setLemburLibur(data.lemburLibur);
    setUangShift(data.shiftSatu);
    setKontrakAwal(data.kontrakAwal);
    setKepalaShift(data.kepalaShift);
    setStatusProbation(data.probation);

    setGajiPokok(data.basicSallary);
    setKurangBayar(data.kurangBayar);
    setPotonganBpjsTK(data.bpjsTK);
    setPotonganBpjsK(data.bpjsK);
    setLebihBayar(data.lebihBayar);
    setUangMakan(data.uangMakan);
    setUangTransport(data.uangTransport);
    setCicilanKasbon(data.kasbon);
    setTidakMasuk(data.tidakMasuk);
    setLembur(data.jamOT);
    setSetengahHari(data.setengahHari / 3600);
    setJamKerja(data.totalWorking / 3600);
    setKeteranganKurangBayar(data.keteranganKurangBayar);
    setKeteranganLebihBayar(data.keteranganLebihBayar);
    setLemburWaktuLibur(data.jamOTLibur);
    setDisplayJamLebih(formatJamKerja(data.jamLebih));
    setWorkingShiftOne(data.workingShiftOne);

    setGajiProbation(data.basicSallaryProbation);
    setLemburLiburProbation(data.lemburLiburProbation);
    setJamKerjaProbation(data.totalWorkingProbation / 3600);
    setProbationStart(data.probationStart);
    setProbationUntil(data.probationUntil);

    setInitialExpand(false);
  };

  useEffect(() => {
    handleCancel(data);
  }, [id]);

  // Ambil signed URL foto dari R2 (hanya kalau karyawan punya foto)
  useEffect(() => {
    let cancelled = false;
    axios
      .post(
        `${process.env.REACT_APP_ENDPOINT}/getFotoKaryawan`,
        { id },
        { headers: { Authorization: `Bearer ${getToken}` } }
      )
      .then((response) => {
        if (cancelled) return;
        setFotoUrl(response.data.code === 200 ? response.data.url : null);
      })
      .catch(() => {
        if (!cancelled) setFotoUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [id]);

  const handlePickFoto = async (e) => {
    const file = e.target.files && e.target.files[0];
    e.target.value = "";
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      setFotoError("File harus berupa gambar.");
      return;
    }
    setFotoLoading(true);
    setFotoError("");
    try {
      const image = await compressImage(file);
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/uploadFotoKaryawan`,
        { id, image },
        { headers: { Authorization: `Bearer ${getToken}` } }
      );
      if (response.data.code === 200) {
        setFotoUrl(response.data.url);
      } else {
        setFotoError(response.data.message || "Gagal mengunggah foto.");
      }
    } catch (error) {
      setFotoError("Gagal mengunggah foto.");
    } finally {
      setFotoLoading(false);
    }
  };

  const handleHapusFoto = async () => {
    setFotoLoading(true);
    setFotoError("");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/deleteFotoKaryawan`,
        { id },
        { headers: { Authorization: `Bearer ${getToken}` } }
      );
      if (response.data.code === 200) {
        setFotoUrl(null);
      } else {
        setFotoError(response.data.message || "Gagal menghapus foto.");
      }
    } catch (error) {
      setFotoError("Gagal menghapus foto.");
    } finally {
      setFotoLoading(false);
    }
  };

  const handleEditUser = async () => {
    if (editType === "Data Diri") {
      if (role.length === 0) {
        setRoleError("Pilih minimal satu role.");
        return;
      }
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/updateUser`,
          {
            id: id,
            type: "editUser",
            part: "dataDiri",
            npwpNumber: noNPWP,
            bankAccountNumber: noRekening,
            name: nama,
            email: email,
            phoneNumber: telepon,
            bagian: bagian,
            alamat: alamat,
            employeeType: valueEmployeeType,
            jumlahAnak: Number(jumlahAnak),
            statusPerkawinan: statusPerkawinan,
            shift: Number(shift),
            role: role, // array
            tempatTanggalLahir: tempatTanggalLahir,
            position: posisi,
            kontrakAwal: kontrakAwal,
            kepalaShift: kepalaShift,
            probation: statusProbation,
            probationStart: probationStart,
            probationUntil: probationUntil,
          },
          {
            headers: {
              Authorization: `Bearer ${getToken}`,
            },
          }
        );
        if (response.data.data.code === 200) {
          handleCancel(response.data.value);
        }
      } catch (error) {
        return error;
      }
    } else if (editType === "Data Keuangan") {
      const hiddenWhenNew = isNewPayroll
        ? {}
        : {
            totalWorking: timeToSecond(jamKerja),
            totalOT: timeToSecond(lembur),
            setengahHari: timeToSecond(setengahHari),
            shiftSatu: Number(uangShift),
            lemburLibur: Number(lemburLibur),
            jamOTLibur: Number(lemburWaktuLibur),
            tidakMasuk: Number(tidakMasuk),
            totalWorkingProbation: timeToSecond(jamKerjaProbation),
            lemburLiburProbation: Number(lemburLiburProbation),
            workingShiftOne: Number(workingShiftOne),
          };

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/updateUser`,
          {
            id: id,
            type: "editUser",
            part: "dataKeuangan",
            basicSallary: Number(gajiPokok),
            kurangBayar: Number(kurangBayar),
            bpjsTK: Number(potonganBpjsTK),
            bpjsK: Number(potonganBpjsK),
            lebihBayar: Number(lebihBayar),
            uangMakan: Number(uangMakan),
            uangTransport: Number(uangTransport),
            kasbon: Number(cicilanKasbon),
            keteranganKurangBayar: keteranganKurangBayar,
            keteranganLebihBayar: keteranganLebihBayar,
            basicSallaryProbation: Number(gajiProbation),
            probationUntil: probationUntil,
            jamLebih: parseJamKerja(displayJamLebih),
            ...hiddenWhenNew,
          },
          { headers: { Authorization: `Bearer ${getToken}` } }
        );

        if (response.data.data.code === 200) {
          handleCancel(response.data.value);
        }
      } catch (error) {
        return error;
      }
    } else if (editType === "Data Kontrak") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getKontrakUser`,
        {
          tim: jsonRole.tim,
        },
        getToken,
        "",
        ""
      );
    }
  };

  const handleAktivasi = async (data, status) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_ENDPOINT}/updateUser`,
        {
          type: "aktivasi",
          status: status,
          id: data,
        },
        {
          headers: {
            Authorization: `Bearer ${getToken}`,
          },
        }
      );
      if (response.data.code === 200) {
        setConfirmation(false);
        setIsReload(true);
      }
    } catch (error) {
      return error;
    }
  };

  const handleConfirmation = (data) => {
    setConfirmation(true);
    setStatusMessage(data);
  };

  const handlePickTanggalStart = (data) => {
    let endDate = moment(data)
      .utcOffset("+0700")
      .add(+13, "days")
      .format("YYYY-MM-DD");

    setProbationStart(data);
    setProbationUntil(endDate);
  };

  const handleBlur = () => {
    const desimal = parseJamKerja(displayJamLebih);
    setDisplayJamLebih(formatJamKerja(desimal));
  };

  const formFooter = (
    <>
      <button className="btn btn--outline" onClick={() => handleCancel(data)}>
        Batal
      </button>
      <button className="btn btn--primary" onClick={() => handleEditUser(data)}>
        Simpan
      </button>
    </>
  );

  return (
    <>
      {confirmation && (
        <Modal
          title="Konfirmasi"
          footer={
            <>
              <button
                className="btn btn--outline"
                onClick={() => setConfirmation(false)}
              >
                Batal
              </button>
              <button
                className="btn btn--primary"
                onClick={() => handleAktivasi(data.id, statusMessage)}
              >
                OK
              </button>
            </>
          }
        >
          <p className="eu-dialog-text">
            Apakah kamu yakin untuk me- {statusMessage} akun ini?
          </p>
        </Modal>
      )}

      <tr className="eu-row">
        {showCheckbox && (
          <td className="col-check">
            <input
              className="checkbox-edituser"
              type="checkbox"
              onChange={(e) => {
                if (e.target.checked) {
                  setPeopleInfo([...peopleInfo, { id: data.id }]);
                } else {
                  setPeopleInfo(
                    peopleInfo.filter((people) => people.id !== data.id)
                  );
                }
              }}
              value={peopleInfo}
            />
          </td>
        )}
        <td className="col-no">{index + 1}.</td>
        <td className="is-clickable" onClick={toggleExpand}>
          <div className="eu-name">
            <Avatar url={fotoUrl} name={data.name} size="sm" />
            {data.probation && <span className="eu-star">&#9733;</span>}
            <span>{data.name}</span>
          </div>
        </td>
        <td className="is-clickable" onClick={toggleExpand}>
          {data.position}
        </td>
        <td className="is-clickable col-center" onClick={toggleExpand}>
          <span
            className={`badge ${isDeactivated ? "badge--bad" : "badge--ok"}`}
          >
            {isDeactivated ? "Habis kontrak" : "Aktif"}
          </span>
        </td>
        {canSeeContract && (
          <td className="col-center">
            <img
              className="eu-contract-icon"
              alt="Kontrak"
              onClick={
                editType === "Data Kontrak"
                  ? () => {
                      setIsPopUpListContract(true);
                      setDataPickHistoryContract(data);
                    }
                  : () => handleOpenNewContract(data)
              }
              src={ContractIcon}
            />
          </td>
        )}
        <td className="is-clickable col-center" onClick={toggleExpand}>
          {data.employeeType}
        </td>
        <td className="col-actions">
          <div className="eu-actions">
            <button
              className="btn btn--sm btn--success"
              onClick={() => handleConfirmation("Aktivasi")}
            >
              Aktifkan
            </button>
            <button
              className="btn btn--sm btn--warn"
              onClick={() => handleConfirmation("Deaktivasi")}
            >
              Nonaktifkan
            </button>
            <button
              className="eu-icon-btn"
              aria-label="Hapus"
              onClick={() => handleConfirmation("Delete")}
            >
              <img src={DeleteIcon} alt="" />
            </button>
          </div>
        </td>
      </tr>

      {/* ---------- Form Data Diri ---------- */}
      {initialExpand && editType === "Data Diri" && (
        <Modal
          title={data.name}
          subtitle="Data diri"
          size="modal--md"
          onClose={() => handleCancel(data)}
          footer={formFooter}
        >
          <div className="foto-upload">
            <Avatar url={fotoUrl} name={data.name} size="lg" />
            <div className="foto-upload__body">
              <div className="foto-upload__actions">
                <input
                  ref={fileInputRef}
                  type="file"
                  accept="image/*"
                  hidden
                  onChange={handlePickFoto}
                />
                <button
                  type="button"
                  className="btn btn--sm btn--outline"
                  disabled={fotoLoading}
                  onClick={() => fileInputRef.current?.click()}
                >
                  {fotoLoading
                    ? "Memproses..."
                    : fotoUrl
                    ? "Ganti foto"
                    : "Upload foto"}
                </button>
                {fotoUrl && (
                  <button
                    type="button"
                    className="btn btn--sm btn--warn"
                    disabled={fotoLoading}
                    onClick={handleHapusFoto}
                  >
                    Hapus foto
                  </button>
                )}
              </div>
              <p className="foto-upload__hint">
                Foto otomatis diperkecil dan langsung tersimpan, tanpa menekan
                Simpan.
              </p>
              {fotoError && <p className="foto-upload__error">{fotoError}</p>}
            </div>
          </div>

          <div className="form-grid">
            <Field label="No. KTP">
              <input type="text" value={data.id} disabled />
            </Field>
            <Field label="No. NPWP">
              <input
                type="text"
                value={noNPWP}
                onChange={(e) => setNoNPWP(e.target.value)}
              />
            </Field>
            <Field label="No. rekening">
              <input
                type="text"
                value={noRekening}
                onChange={(e) => setNoRekening(e.target.value)}
              />
            </Field>

            <Field label="Nama">
              <input
                type="text"
                value={nama}
                onChange={(e) => setNama(e.target.value)}
              />
            </Field>
            <Field label="Email">
              <input
                type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Field>
            <Field label="No. telepon">
              <input
                type="number"
                value={telepon}
                onChange={(e) => setTelepon(e.target.value)}
              />
            </Field>

            <Field label="Tempat tanggal lahir">
              <input
                type="text"
                value={tempatTanggalLahir}
                onChange={(e) => setTempatTanggalLahir(e.target.value)}
              />
            </Field>
            <Field label="Status perkawinan">
              <div className="radio-group">
                <Radio
                  label="Kawin"
                  checked={statusPerkawinan === "KAWIN"}
                  onSelect={() => setStatusPerkawinan("KAWIN")}
                />
                <Radio
                  label="Tidak kawin"
                  checked={statusPerkawinan === "TIDAK KAWIN"}
                  onSelect={() => setStatusPerkawinan("TIDAK KAWIN")}
                />
              </div>
            </Field>
            <Field label="Jumlah anak">
              <input
                type="number"
                value={jumlahAnak}
                onChange={(e) => setJumlahAnak(e.target.value)}
              />
            </Field>

            <Field label="Alamat" full>
              <textarea
                value={alamat}
                onChange={(e) => setAlamat(e.target.value)}
              />
            </Field>

            <Field label="Posisi">
              <select
                value={posisi}
                onChange={(e) => setPosisi(e.target.value)}
              >
                <option value="" disabled hidden>
                  Pilih posisi
                </option>
                {posisiConstant.map((item) => (
                  <option key={item} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Bagian">
              <select
                value={bagian}
                onChange={(e) => setBagian(e.target.value)}
              >
                <option value="" disabled hidden>
                  Pilih bagian
                </option>
                {BagianConstant.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Shift">
              <select value={shift} onChange={(e) => setShift(e.target.value)}>
                <option value="" disabled hidden>
                  Pilih shift
                </option>
                <option value="1">Shift 1</option>
                <option value="2">Shift 2</option>
                <option value="3">Shift 3</option>
              </select>
            </Field>
            <Field label="Kepala shift">
              <select
                value={kepalaShift}
                onChange={(e) => setKepalaShift(e.target.value)}
              >
                <option value="Pilih Kepala" disabled>
                  Pilih kepala
                </option>
                {validateData.map((item) => (
                  <option key={item.value} value={item.value}>
                    {item.name}
                  </option>
                ))}
              </select>
            </Field>
            <Field label="Jenis karyawan">
              <div className="radio-group">
                <Radio
                  label="Permanen"
                  checked={valueEmployeeType === "Permanent"}
                  onSelect={() => setValueEmployeeType("Permanent")}
                />
                <Radio
                  label="Kontrak"
                  checked={valueEmployeeType === "Contract"}
                  onSelect={() => setValueEmployeeType("Contract")}
                />
              </div>
            </Field>
            <Field label="Kontrak awal">
              <input
                type="text"
                value={kontrakAwal}
                onChange={(e) => setKontrakAwal(e.target.value)}
              />
            </Field>

            <Field label="Role (bisa lebih dari satu)" full>
              <div className="role-group">
                {RoleConstant.map((item) => (
                  <label
                    key={item}
                    className={`role-chip ${
                      role.includes(item) ? "is-on" : ""
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={role.includes(item)}
                      onChange={() => toggleRole(item)}
                    />
                    <span>{item}</span>
                  </label>
                ))}
              </div>
              {roleError && <p className="foto-upload__error">{roleError}</p>}
            </Field>
          </div>
          <br />

          <div className="form-section">
            <h4 className="form-section__title">Masa percobaan</h4>
            <div className="form-grid">
              <Field label="Status percobaan">
                <div className="radio-group">
                  <Radio
                    label="Ya"
                    checked={statusProbation === true}
                    onSelect={() => setStatusProbation(true)}
                  />
                  <Radio
                    label="Tidak"
                    checked={statusProbation === false}
                    onSelect={() => setStatusProbation(false)}
                  />
                </div>
              </Field>
              <Field label="Percobaan dari">
                <input
                  type="date"
                  value={probationStart}
                  onChange={(e) => handlePickTanggalStart(e.target.value)}
                />
              </Field>
              <Field label="Percobaan sampai">
                <div className="field__value">{probationUntil}</div>
              </Field>
            </div>
          </div>
        </Modal>
      )}

      {/* ---------- Form Data Keuangan ---------- */}
      {initialExpand && editType === "Data Keuangan" && (
        <Modal
          title={data.name}
          subtitle="Data keuangan"
          size="modal--lg"
          onClose={() => handleCancel(data)}
          footer={formFooter}
        >
          <div className="form-section">
            <h4 className="form-section__title">Pemasukan</h4>
            <div className="form-grid">
              <Field label="No. KTP">
                <input type="text" value={data.id} disabled />
              </Field>
              <Field label="Gaji pokok">
                <input
                  type="number"
                  value={gajiPokok}
                  onChange={(e) => setGajiPokok(e.target.value)}
                />
              </Field>

              {!isNewPayroll && (
                <Field label="Shift 1 (hari)">
                  <input
                    type="number"
                    value={uangShift}
                    onChange={(e) => setUangShift(e.target.value)}
                  />
                </Field>
              )}

              <Field label="Uang makan">
                <input
                  type="number"
                  value={uangMakan}
                  onChange={(e) => setUangMakan(e.target.value)}
                />
              </Field>
              <Field label="Uang transport">
                <input
                  type="number"
                  value={uangTransport}
                  onChange={(e) => setUangTransport(e.target.value)}
                />
              </Field>
              <Field label="Kurang bayar">
                <input
                  type="number"
                  value={kurangBayar}
                  onChange={(e) => setKurangBayar(e.target.value)}
                />
              </Field>
              <Field label="Ket. kurang bayar">
                <input
                  type="text"
                  value={keteranganKurangBayar}
                  onChange={(e) => setKeteranganKurangBayar(e.target.value)}
                />
              </Field>

              {!isNewPayroll && (
                <>
                  <Field label="Lembur libur (hari)">
                    <input
                      type="number"
                      value={lemburLibur}
                      onChange={(e) => setLemburLibur(e.target.value)}
                    />
                  </Field>
                  <Field label="Lembur (jam)">
                    <input
                      type="number"
                      value={lembur}
                      onChange={(e) => setLembur(Number(e.target.value))}
                    />
                  </Field>
                  <Field label="Lembur waktu libur (jam)">
                    <input
                      type="number"
                      value={lemburWaktuLibur}
                      onChange={(e) =>
                        setLemburWaktuLibur(Number(e.target.value))
                      }
                    />
                  </Field>
                  <Field label="Jam kerja (jam)">
                    <input
                      type="number"
                      value={jamKerja}
                      onChange={(e) => setJamKerja(Number(e.target.value))}
                    />
                  </Field>
                  <Field label="Setengah hari (jam)">
                    <input
                      type="number"
                      value={setengahHari}
                      onChange={(e) => setSetengahHari(Number(e.target.value))}
                    />
                  </Field>
                </>
              )}
              <Field label="Jam lebih">
                <input
                  type="text"
                  inputMode="decimal"
                  value={displayJamLebih}
                  onChange={(e) => setDisplayJamLebih(e.target.value)}
                  onBlur={handleBlur}
                />
              </Field>
            </div>
          </div>

          <div className="form-section">
            <h4 className="form-section__title">Masa percobaan</h4>
            <div className="form-grid">
              <Field label="Gaji probation" danger>
                <input
                  type="number"
                  value={gajiProbation}
                  onChange={(e) => setGajiProbation(Number(e.target.value))}
                />
              </Field>

              {!isNewPayroll && (
                <>
                  <Field label="Jam kerja probation" danger>
                    <input
                      type="number"
                      value={jamKerjaProbation}
                      onChange={(e) =>
                        setJamKerjaProbation(Number(e.target.value))
                      }
                    />
                  </Field>
                  <Field label="Lembur libur probation" danger>
                    <input
                      type="number"
                      value={lemburLiburProbation}
                      onChange={(e) =>
                        setLemburLiburProbation(Number(e.target.value))
                      }
                    />
                  </Field>
                  {hasRole(jsonRole, "super_user") && (
                    <Field label="Working shift one" danger>
                      <input
                        type="number"
                        value={workingShiftOne}
                        onChange={(e) =>
                          setWorkingShiftOne(Number(e.target.value))
                        }
                      />
                    </Field>
                  )}
                </>
              )}
            </div>
          </div>

          <div className="form-section">
            <h4 className="form-section__title">Pengeluaran</h4>
            <div className="form-grid">
              <Field label="Lebih bayar">
                <input
                  type="number"
                  value={lebihBayar}
                  onChange={(e) => setLebihBayar(e.target.value)}
                />
              </Field>
              <Field label="Ket. lebih bayar">
                <input
                  type="text"
                  value={keteranganLebihBayar}
                  onChange={(e) => setKeteranganLebihBayar(e.target.value)}
                />
              </Field>
              <Field label="BPJS Tenaga Kerja">
                <input
                  type="number"
                  value={potonganBpjsTK}
                  onChange={(e) => setPotonganBpjsTK(e.target.value)}
                />
              </Field>
              <Field label="BPJS Kesehatan">
                <input
                  type="number"
                  value={potonganBpjsK}
                  onChange={(e) => setPotonganBpjsK(e.target.value)}
                />
              </Field>

              {!isNewPayroll && (
                <Field label="Tidak masuk (jam)">
                  <input
                    type="number"
                    value={tidakMasuk}
                    onChange={(e) => setTidakMasuk(e.target.value)}
                  />
                </Field>
              )}
            </div>
          </div>
        </Modal>
      )}

      {/* ---------- Data Kontrak (hanya header, seperti sebelumnya) ---------- */}
      {initialExpand && editType === "Data Kontrak" && (
        <Modal title={data.name} onClose={() => setInitialExpand(false)} />
      )}
    </>
  );
};
export default AccordionEditUser;
